<div class="modal-header blue">
  <h4 class="modal-title">Change User Password</h4>
  <a href="javascript:void(0)" (click)="close()" class="modal-close-btn"></a>
</div>

<div class="modal-body" [class.loading]="isLoading">
  <form [formGroup]="form">
    <div class="mb-3">
      <div class="input-label">
        <span class="standart-text-required-symbol">*</span>
        Old Password
      </div>

      <input
        type="password"
        placeholder="Enter Old Password"
        class="input"
        formControlName="oldPassword"
        password-toggle
        [class.is-invalid]="
          form.get('oldPassword')?.touched && form.get('oldPassword')?.invalid
        "
      />

      <div
        class="invalid-feedback text-left"
        *ngIf="
          form.get('oldPassword')?.invalid && form.get('oldPassword')?.touched
        "
      >
        <span *ngIf="form.get('oldPassword')?.errors?.required"
          >This field is required</span
        >
      </div>
    </div>

    <div class="mb-3">
      <div class="input-label">
        <span class="standart-text-required-symbol">*</span>
        New Password
      </div>

      <input
        type="password"
        placeholder="Enter New Password"
        class="input"
        formControlName="password"
        password-toggle
        [class.is-invalid]="
          form.get('password')?.touched && form.get('password')?.invalid
        "
      />

      <div
        class="invalid-feedback text-left d-block"
        *ngIf="form.get('password')?.invalid && form.get('password')?.touched"
      >
        <div *ngIf="form.get('password')?.errors?.required">
          This field is required
        </div>

        <div
          *ngIf="form.get('password')?.errors?.passwordRequirments"
          [innerHTML]="form.get('password')?.errors?.passwordRequirments"
          style="white-space: pre-line"
        ></div>
      </div>
    </div>

    <div>
      <div class="input-label">
        <span class="standart-text-required-symbol">*</span>
        Confirm Password
      </div>

      <input
        type="password"
        placeholder="Enter Password Confirmation"
        class="input"
        formControlName="confirmPassword"
        password-toggle
        [class.is-invalid]="
          form.get('confirmPassword')?.touched &&
          form.get('confirmPassword')?.invalid
        "
      />

      <div
        class="invalid-feedback text-left d-block"
        *ngIf="
          form.get('confirmPassword')?.invalid &&
          form.get('confirmPassword')?.touched
        "
      >
        <div *ngIf="form.get('confirmPassword')?.errors?.required">
          This field is required
        </div>

        <div *ngIf="form.get('confirmPassword')?.errors?.sameAsOriginal">
          Confirm Password field not equal to Password
        </div>

        <div
          *ngIf="form.get('confirmPassword')?.errors?.passwordRequirments"
          [innerHTML]="form.get('confirmPassword')?.errors?.passwordRequirments"
          style="white-space: pre-line"
        ></div>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button
    class="button w-134px ml-auto"
    [disabled]="form.invalid"
    (click)="onSubmit()"
  >
    Save & Close
  </button>
</div>
